import { isAxiosError } from 'axios';
import { apiClient } from '@/axios';
import { Endpoints } from '@/enums';
import { SolasInfo } from './types';

type GetSOLASResponse = {
  state: number;
  value: SolasInfo[];
};

export const getSOLAS = async (): Promise<SolasInfo[]> => {
  try {
    const res = await apiClient.post<GetSOLASResponse>(Endpoints.SolasList);
    return res.data.value;
  } catch (error) {
    if (isAxiosError(error)) {
      throw new Error(error.message);
    }
    throw error;
  }
};
